module.exports = __webpack_public_path__ + "static/media/bronn.410ba2e4.jpg";